import React, { useState, useEffect } from "react";
import { shoppingCart } from "../../common/data/ecommerce";

//Import Breadcrumb
import { Link } from "react-router-dom";

import {
  Card,
  CardBody,
  Col,
  Container,
  Input,
  Row,
  CardHeader,
  UncontrolledAlert,
} from "reactstrap";

const VideoCollectionHeader = () => {
  // document.title = "Shopping Cart | Velzon - React Admin & Dashboard Template";

  return (
    <React.Fragment>
      <Col xs={12} className="d-flex text-center justify-content-center">
        <div className="width-mobile-50">
          <h4 className="text-2 text-color5 mb-4" style={{display:"none"}}>Video Collection</h4>
          <h6 className="text-1 text-color4 mb-4">
            Empower Your Learning Journey. Explore diverse courses. Engaging content. Expert instructors. Unlock new skills. Enroll now and embark on limitless learning!
          </h6>
        </div>
      </Col>
    </React.Fragment>
  );
};

export default VideoCollectionHeader;
